var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab',_vm._b({staticClass:"blue-grey lighten-5",attrs:{"ripple":false}},'v-tab',_vm.$attrs,false),[_c('div',[_c('span',{staticClass:"text-subtitle-2"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"caption ml-1"},[_vm._v("("+_vm._s(_vm.count)+")")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }